import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedGuard implements CanActivate {

  private authenticationService = inject(AuthenticationService);

  private readonly MAX_WAIT = 500;

  /**
   * wait max MAX_WAIT ms until authenticated
   * @param next
   * @param state
   */
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const start = Date.now();
    return this.authenticationService.authenticated$.pipe(
      debounce((authenticated) => {
        const now = Date.now();
        if (authenticated) {
          return timer(0);
        } else {
          return timer(Math.max(0, now - start + this.MAX_WAIT));
        }
      })
    );
  }
}
